import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdToUnitPipe } from './pipes/idToUnit/id-to-unit.pipe';
import { PageLoaderComponent } from './components/page-loader/page-loader.component';
import { ConvertDatePipe } from './pipes/convertDate/convert-date.pipe';
import { VendorNamePipe } from './pipes/vendorName/vendor-name.pipe';
import { ConvertDateTimeToDatePipe } from './pipes/convertDateTimeToDate/convert-date-time-to-date.pipe';
import { IdToLocationPipe } from './pipes/idToLocation/id-to-location.pipe';
import { OrderStatusPipe } from './pipes/orderStatus/order-status.pipe';
import { ConvertDateTimeToTimePipe } from './pipes/convertDateTimeToTime/convert-date-time-to-time.pipe';
import { TimeDifferencePipe } from './pipes/timeDifference/time-difference.pipe';
import { DatePickerComponent } from './components/date-picker/date-picker.component';

import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDataTableComponent } from './components/custom-data-table/custom-data-table.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { ConvertSnakeCaseToTitlePipe } from './pipes/convertSnakeCaseToTitle/convert-snake-case-to-title.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ConvertDashCaseToTitlePipe } from './pipes/convertDashCaseToTitle/convert-dash-case-to-title.pipe';
import { TableLoaderComponent } from './components/table-loader/table-loader.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    IdToUnitPipe,
    PageLoaderComponent,
    ConvertDatePipe,
    VendorNamePipe,
    ConvertDateTimeToDatePipe,
    IdToLocationPipe,
    OrderStatusPipe,
    ConvertDateTimeToTimePipe,
    TimeDifferencePipe,
    DatePickerComponent,
    CustomDataTableComponent,
    TimelineComponent,
    ConvertSnakeCaseToTitlePipe,
    ConvertDashCaseToTitlePipe,
    TableLoaderComponent,
    PaginatorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    TranslateModule,
    NgSelectModule,
  ],
  exports: [
    IdToUnitPipe,
    PageLoaderComponent,
    ConvertDatePipe,
    VendorNamePipe,
    ConvertDateTimeToDatePipe,
    ConvertDateTimeToTimePipe,
    IdToLocationPipe,
    OrderStatusPipe,
    TimeDifferencePipe,
    DatePickerComponent,
    CustomDataTableComponent,
    TimelineComponent,
    ConvertSnakeCaseToTitlePipe,
    ConvertDashCaseToTitlePipe,
    TableLoaderComponent,
    PaginatorComponent,
  ],
})
export class SharedModule {}
